import { bugsnagError } from 'services/bugsnag';
import warehouse from 'services/warehouse';

export const setAllRetailerPromos = (payload) => ({
  type: 'DS_PROMOS/SET_ALL_PROMOS',
  payload
});

/**
 *  setRetailerPromoObject takes the warehouse.fetchAllPromos response as an input,
 *  and returns an object as an output with the following structure:
 *  {
 *    retailerName1: ['promo1', 'promo2'],
 *    retailerName2: ['promo3'],
 *    retailerName3: ['promo4']
 *  }
 */
export const setRetailerPromoObject = (response) => {
  let retailerPromos = {};
  const sourceDiscounts = response.results;

  sourceDiscounts.forEach(sourceDiscount => {
    const retailerName = sourceDiscount.source.name;
    const retailerPromo = sourceDiscount.description;

    if (retailerPromos[retailerName]) {
      retailerPromos[retailerName].push(retailerPromo);
    } else {
      retailerPromos[retailerName] = [retailerPromo];
    }
  });
  return retailerPromos;
};

export const updateAllRetailerPromos = () => (dispatch) => {
  return warehouse.fetchAllPromos()
    .then(responseData => {
      let retailerPromos = setRetailerPromoObject(responseData);
      dispatch(setAllRetailerPromos(retailerPromos));
    }).catch(error => {
      bugsnagError(error);
    });
};
